<template>
  <div class="content-main">
    <section class="featured" id="featured">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title-index">
            <h2>Recursos</h2>
          </div>
        </div>
      </div>
      <!-- <splide :options="cardsSplide">
        <splide-slide> -->
      <div class="row">
        <div class="grid-login-title">
          <h2>Capitação Ponderada</h2>
        </div>
      </div>
      <div class="row login-cards">
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-people"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Cadastros Individuais por ACS</h4>
              <p>Cadastro populacional feito pela eSF e/ou eAP</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-copy-invert"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Cidadãos Duplicados</h4>
              <p>Pessoas com mais de um cadastro</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-people"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Cidadãos Desvinculados</h4>
              <p>Cidadãos sem vinculação com qualquer equipe</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-users-alt-4"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Cidadãos visitados</h4>
              <p>
                Última visita realizada por cidadão nos últimos 5 meses
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-users-alt-4"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Cidadãos sem ACS</h4>
              <p>Cidadãos sem vinculação com qualquer ACS</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-users-alt-4"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">ACS por cidadão</h4>
              <p>Dados do cidadão (Imprimir cartão SUS, equipe e ACS)</p>
            </div>
          </div>
        </div>
      </div>
      <!-- </splide-slide>
        <splide-slide> -->
      <div class="row">
        <div class="grid-login-title">
          <h2>Indicadores</h2>
        </div>
      </div>
      <div class="row login-cards">
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-injection-syringe"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Vacinas polio e penta</h4>
              <p>Crianças menores de 1 ano</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-baby"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Consultas pré-natal</h4>
              <p>Consultas de Pré-Natal realizadas em gestantes</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-tooth"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Consultas odontológicas</h4>
              <p>Consultas odontológicas realizadas em gestantes</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-blood-test"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">HIV e Sífilis</h4>
              <p>Exames para detecção de Sífilis e HIV em gestantes</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-blood-drop"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Atendimento hipertensão</h4>
              <p>Consultas em hipertensos e aferição de PA</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-users-alt-4"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Hemoglobina glicada</h4>
              <p>Exames de hemoglobina glicada</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-users-alt-4"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Exames citopatológicos</h4>
              <p>Citopatológicos em mulheres de 25 a 64 anos</p>
            </div>
          </div>
        </div>
      </div>
      <!-- </splide-slide>
        <splide-slide> -->
      <div class="row">
        <div class="grid-login-title">
          <h2>Ações estratégicas</h2>
        </div>
      </div>
      <div class="row login-cards">
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-info-circle"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Informatiza APS</h4>
              <p>Atendimentos por função no mês atual</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-list"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Atendimentos no mês</h4>
              <p>Atendimentos realizados no últimos 30 dias</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-loop"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Envio APP ACS PEC</h4>
              <p>Última visita do ACS encontrada no PEC</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-loop"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Profissionais PEC CNES</h4>
              <p>Validação de profissionais entre PEC e CNES</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="media service-box">
            <div class="pull-left">
              <i class="icofont-eye-alt"></i>
            </div>
            <div class="media-body">
              <h4 class="media-heading">Últimas visualizações</h4>
              <p>Profissionais que acessaram o eSUS Feedback</p>
            </div>
          </div>
        </div>
      </div>
      <!-- </splide-slide>
      </splide> -->
    </section>
  </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css'

export default {
  name: 'Recursos',
  components: {
    Splide,
    SplideSlide
  },
  data() {
    return {
      optionsSplide: {
        rewind: true,
        width: 1140,
        perPage: 1,
        gap: '1rem',
        breakpoints: {
          '640': {
            perPage: 1,
            gap: '1rem',
            width: 360
          },
          '480': {
            perPage: 1,
            gap: '1rem',
            width: 360
          },
          '768': {
            perPage: 1,
            gap: '1rem',
            width: 768
          }
        }
      },
      cardsSplide: {
        rewind: true,
        autoplay: true,
        width: 1170,
        perPage: 1,
        gap: '0.6rem',
        breakpoints: {
          '640': {
            perPage: 1,
            gap: '1rem',
            width: 360
          },
          '480': {
            perPage: 1,
            gap: '1rem',
            width: 360
          }
        },
        arrows: false
      }
    }
  }
}
</script>

<style>
.featured {
  padding: 0 !important;
}
</style>
